import React from 'react'

const Tagline1 = () => (
  <div className="row tagline-1">
    <div className="col">
      <h3>
        <span>React</span> <span>Redux</span> <span>Bootstrap 4</span> admin
        template
      </h3>
      <h4>
        Includes <span>3 layouts</span>, <span>8 navbar</span> and{' '}
        <span>sidebar color styles</span>, 3 example dashboards and <br />
        more than
        <span>100+ pages</span> and <span>500+ widgets</span>
      </h4>
    </div>
  </div>
)
export default Tagline1



// WEBPACK FOOTER //
// ./src/pages/home/Tagline1.js